export function getCoveringLetterProcessorId(templateVariable: string): string | null {
  const match = templateVariable && templateVariable.match(/^podepisujici\d+/);
  return match ? match[0] : null;
}

export function transformCoveringLetterProcessor<T extends { templateVariable: string }>(processor: { items: T[] }): T[] {
  return processor.items.map(item => ({
    ...item,
    templateVariable: item.templateVariable.replace(/^podepisujici\d+/, 'podepisujici'),
  }));
}
